import React, { Component } from 'react';

import { Button, Input, Checkbox, Form, Modal, TextArea, Grid, Select, Message } from 'semantic-ui-react'
import axios from 'axios'
import DatePicker from 'react-datepicker';
// import { Link } from 'react-router-dom'
import './post.scss'
import '../navbar/navbar_main.scss';


class PostHouse extends Component {
    constructor() {
        super();

        this.state = {
            data: '',
            type: '',
            startDate: '',
            endDate: '',
            description: '',
            showModal: false,
            loading: false,
            error: null
        };
        this.startdateChange = this.startdateChange.bind(this);
        this.enddateChange = this.enddateChange.bind(this);
        this.typeChangeHandler = this.typeChangeHandler.bind(this);
        this.descriptionChangeHandler = this.descriptionChangeHandler.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    // clickHandler() {
    //     // Form the URL
    //     let url = `${this.baseUrl}`;
    //     let content = '';
    //     axios.post(url, content).then((response) => {
    //         console.log(response);

    //         this.setState({
    //             data: response.data.results
    //         });

    //         console.log(this.state.data);
    //     }).catch((error) => {
    //         console.log(error);
    //     });
    // }
    onSubmit(event) {
        event.preventDefault();
        // const owner = JSON.stringify(localStorage.getItem('user'))._id;
        const owner = JSON.parse(localStorage.getItem('user'))._id
        const address = document.querySelector('#address').value;
        const city = document.querySelector('#city').value;
        const state = document.querySelector('#state').value;
        const zipcode = document.querySelector('#zipcode').value;


        const cost = document.querySelector('#cost').value;
        const description = this.state.description;

        const type = this.state.type;
        //  document.querySelector('#type').value;
        console.log('type' + type);
        // 
        const startdate = this.state.startDate;
        const enddate = this.state.endDate;
        const photo = document.querySelector('#photo').value;
        var houseId;
        if (!address || !city || !state || !zipcode || !type || !startdate || !enddate) {
            console.log('wat');
            this.setState({
                error: true
            })
        } else {
            // Form the URL  POST email and passwor; get a token and a user id
            let url = `http://node-express-env.yhwg8jeyei.us-west-2.elasticbeanstalk.com/api/houses`;
            var user = JSON.parse(localStorage.getItem('user'))

            console.log(user._id, {
                owner: owner, address: address, city: city,
                state: state, description: description, zipcode: zipcode, type: type, start_Date: startdate, end_Date: enddate
            })
            // let url = 'localhost:8081/api/houses/'
            axios.post(url, {
                owner: owner, address: address, city: city,
                state: state, description: description, cost: cost, zipcode: zipcode, type: type, start_Date: startdate, end_Date: enddate, photo: [photo]
            }).then((response) => {
                console.log(response);
                //TODO
                var houseId = response.data.data._id;
                var user = localStorage.getItem('user');
                var user = localStorage.getItem('user');
                user = JSON.parse(user);
                console.log(user.myHouse);
                user.myHouse.push(houseId);
                var user = localStorage.setItem('user', JSON.stringify(user));

                window.location = `${process.env.PUBLIC_URL}/users/profile`;
            }).catch((error) => {
                console.log(error);
                this.setState({
                    error: true
                })
            });
        }

        this.setState({
            type: ''
        });

    }
    startdateChange(date) {
        this.setState({
            startDate: date
        });
    }

    enddateChange(date) {
        this.setState({
            endDate: date
        });
    }

    typeChangeHandler = (e, { value }) => {
        this.setState({
            type: value
        })
        console.log('set type state' + value + this.state.type)
    }
    descriptionChangeHandler = (e) => this.setState({
        description: e.target.value
    })
    render() {
        const options = [
            { key: 'sublease', text: 'Sublease', value: 'sublease' },
            { key: 'first_hand', text: 'First Hand', value: 'first_hand' },
            { key: 'roommate_needed', text: 'Roommate Needed', value: 'roommate_needed' },
        ];
        return (
            <div>


                <Modal size="tiny" trigger={<button
                    className="navbar-button"
                >Post New</button>}>
                    <Modal.Header>Post a new house</Modal.Header>
                    {this.state.error &&
                        <Message warning style={{ width: "80%", margin: "auto" }}>
                            <Message.Header>Please fill in all required information!</Message.Header>
                        </Message>
                    }
                    <Modal.Content>
                        <div className='postform'>
                            <Grid>
                                <Grid.Row centered>
                                    <Form>

                                        <Form.Field required>
                                            <Input
                                                id='address'
                                                label='Address*'
                                                placeholder='Address'
                                            />
                                        </Form.Field>
                                        <Form.Field required>
                                            <Input
                                                id='city'
                                                label='City*'
                                                placeholder='City'
                                            />
                                        </Form.Field>
                                        <Form.Field required>
                                            <Input
                                                id='state'
                                                label='State*'
                                                placeholder='State'
                                            />
                                        </Form.Field>
                                        <Form.Field required>
                                            <Input
                                                id='zipcode'
                                                label='Zipcode*'
                                                placeholder='Zipcode'
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Input
                                                id='cost'
                                                type="number"
                                                label='Cost'
                                                placeholder='Cost'
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Input
                                                id='photo'
                                                label='Photo'
                                                placeholder='Input the photo url'
                                            />
                                        </Form.Field>
                                        <Form.Field
                                            control={TextArea}
                                            id='description'
                                            label='Description'
                                            placeholder='Description'
                                            onChange={this.descriptionChangeHandler}
                                        />
                                        <Form.Group>
                                            <Form.Field required>
                                                <label>CHECK-IN DATE</label>
                                                <DatePicker className="dpicker" selected={this.state.startDate} onChange={this.startdateChange} />
                                            </Form.Field>
                                            <Form.Field required>
                                                <label>CHECK-OUT DATE</label>
                                                <DatePicker className="dpicker" selected={this.state.endDate} onChange={this.enddateChange} />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Field required>

                                            <Select id='type' placeholder='Select your post type*' options={options} onChange={this.typeChangeHandler} />
                                        </Form.Field>
                                        <Button className='navbar-button' type='submit' onClick={this.onSubmit}>Submit</Button>

                                    </Form>
                                </Grid.Row>
                            </Grid>
                        </div>

                    </Modal.Content>
                </Modal>
            </div>

        )
    }

}

export default PostHouse
